Ext.ns('mx.comp');

mx.comp.PagingToolbar = Ext.extend(Ext.PagingToolbar, {
    readOnly: false,
    pageSize: 30,
    pageSizes: [15, 30, 60],
    buttonsClick: Ext.emptyFn,
    paramNames: {start: 'startIndex', limit: 'results'},
    name: 'paging_toolbar',

    cls: 'mx-comp-pagingtoolbar',
    labels: {
        add: 'Add',
        del: 'Delete',
        imprt: 'Import...',
        showing: 'Show',
        itemsPerPage: 'items per page',
        //
        displayMsg: 'Displaying {0} - {1} of {2}',
        emptyMsg: 'No data to display',
        beforePageText: 'Page',
        afterPageText: 'of {0}',
        firstText: 'First Page',
        prevText: 'Previous Page',
        nextText: 'Next Page',
        lastText: 'Last Page',
        refreshText: 'Refresh',
    },
    uniqName: '',
    addButtonObj: null,
    delButtonObj: null,
    pageSizeCookieName: null,

    initComponent: function() {
        mx.comp.PagingToolbar.superclass.initComponent.call(this);

        this.displayMsg = this.labels.displayMsg;
        this.emptyMsg = this.labels.emptyMsg;
        this.beforePageText = this.labels.beforePageText;
        this.afterPageText = this.labels.afterPageText;
        this.firstText = this.labels.firstText;
        this.prevText = this.labels.prevText;
        this.nextText = this.labels.nextText;
        this.lastText = this.labels.lastText;
        this.refreshText = this.labels.refreshText;
    },

    onRender: function() {
        /*
         * We use ugly hack on overriden functions calling just to insert code
         * between
         * Ext.PagingToolbar.superclass.onRender
         * and
         * mx.comp.PagingToolbar.superclass.onRender
         * ...shame on ExtJS developers
         **/

        // Ugly hack {
        Ext.PagingToolbar.superclass.onRender.apply(this, arguments);
        // } Ugly hack

        if (!this.readOnly || this.readOnly.length) {
            if (this.readOnly.length == 0) {
                this.readOnly = [false, false];
            }
            if (!this.readOnly[0]) {
                this.addButtonObj = this.addButton({
                    text: this.labels.add,
                    iconCls: 'addbutton',
                    name: 'mx.comp.PagingToolbar.AddButton' + this.uniqName,
                    handler: this.buttonsClick.createDelegate(this, ['add']),
                });
            }
            if (!this.readOnly[1]) {
                this.delButtonObj = this.addButton({
                    text: this.labels.del,
                    iconCls: 'delbutton',
                    name: 'mx.comp.PagingToolbar.DeleteButton' + this.uniqName,
                    handler: this.buttonsClick.createDelegate(this, ['delete']),
                    disabled: true,
                });
            }
        }

        if (this.controlsOnTheLeft) {
            for (var i = 0; i < this.controlsOnTheLeft.length; i++) {
                this.add(this.controlsOnTheLeft[i]);
            }
        }
        if (this.buttonsOnTheLeft) {
            for (var i = 0; i < this.buttonsOnTheLeft.length; i++) {
                this.addButton(this.buttonsOnTheLeft[i]);
            }
        }

        this.add({xtype: 'mx_tbfill'});

        // Ugly hack {
        var tmp = Ext.PagingToolbar.superclass.onRender;
        Ext.PagingToolbar.superclass.onRender = Ext.emptyFn;
        mx.comp.PagingToolbar.superclass.onRender.apply(this, arguments);
        Ext.PagingToolbar.superclass.onRender = tmp;
        // } Ugly hack

        this.initPageSizeValue();
        this.add(this.labels.showing);
        this.add((this.pageSizeCombo = this.createPageSizeCombo()));
        this.add(this.labels.itemsPerPage);
        this.add({xtype: 'mx_tbfill'});
    },

    //protected
    initPageSizeValue: function() {
        if (this.pageSizeCookieName) {
            var pageSize = mx.Util.Cookies.get('gt.pagingbar.' + this.pageSizeCookieName);
            if (pageSize) {
                this.pageSize = pageSize;
            }
        }
    },

    //protected
    getPageSizeValueList: function() {
        return this.pageSizes;
    },

    //protected
    onPageSizeSelected: function(pageSize) {
        if (this.pageSizeCookieName) {
            mx.Util.Cookies.set('gt.pagingbar.' + this.pageSizeCookieName, pageSize);
        }
    },

    //protected
    createPageSizeCombo: function() {
        var values = this.getPageSizeValueList();
        var pageSizeList = [];
        for (var i = 0; i < values.length; i++) {
            pageSizeList.push([values[i]]);
        }

        return new Ext.form.ComboBox({
            forceSelection: true,
            triggerAction: 'all',
            displayField: 'page',
            store: new Ext.data.SimpleStore({
                fields: ['page'],
                data: pageSizeList,
            }),
            value: this.pageSize,
            mode: 'local',
            width: 45,
            name: 'mx.comp.PagingToolbar.ItemsPerPage' + this.uniqName,
            listeners: {
                select: function(combo, record, index) {
                    this.pageSize = record.get('page');
                    this.onPageSizeSelected(this.pageSize);
                    this.doLoad(0);
                }.createDelegate(this),
            },
        });
    },
});

Ext.reg('mx_paging_toolbar', mx.comp.PagingToolbar);

mx.comp.PagingToolbar.Fill = Ext.extend(Ext.Toolbar.Spacer, {
    // private
    render: function(td) {
        td.style.width = '50%';
        mx.comp.PagingToolbar.Fill.superclass.render.call(this, td);
    },
});
Ext.reg('mx_tbfill', mx.comp.PagingToolbar.Fill);
